import { convertIsoToString } from './utilities'

export function normalizeProject(project: IProject): IProject {
  if (project) {
    return {
      ...project,
      start_date: convertIsoToString(project.start_date),
      end_date: convertIsoToString(project.end_date)
    }
  }
}
